module.exports = __webpack_public_path__ + "1c6c0919f4b146dba1fda9a8c0d5b7c5.MP3";